
import BaseAlert from "@/components/base/BaseAlert.vue";
import BaseButton from "@/components/base/BaseButton.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import useAccount from "@/composables/useAccount";
import useAccountPages from "@/composables/useAccountPages";
import usePassengerDetailPages from "@/composables/usePassengerDetailPages";
import { focusElement } from "@/helpers/focusHelper";
import { Component, UserType } from "@/models/enums";
import { useUserStore } from "@/store/user";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { defineComponent, onMounted, reactive, ref } from "vue";

export default defineComponent({
	components: {
		BaseInput,
		BaseButton,
		BaseAlert,
	},
	props: {
		enableCreate: {
			type: Boolean,
			required: false,
			default: true,
		},
		isAgent: {
			type: Boolean,
			default: false,
		}
	},
	setup(props) {
		const userStore = useUserStore();
		const { login } = useAccount();
		const accountPages = useAccountPages();
		const passengerDetailPages = usePassengerDetailPages();

		const error = ref();
		const loading = ref<boolean>(false);
		const emailLocked = ref<boolean>(
			props.enableCreate && userStore.getUser.email ? true : false
		);

		const passwordRef = ref<HTMLElement>();

		const state = reactive({
			userName: userStore.getUser.email ?? "",
			password: "",
		});

		const rules = {
			userName: { required },
			password: { required },
		};

		const v$ = useVuelidate(rules, state);

		const unlockEmail = () => {
			emailLocked.value = false;
		};

		const goToRegister = () => {
			accountPages.setComponent(Component[Component.AccountRegistration]);
		};

		const goToForgotPassword = () => {
			accountPages.setComponent(Component[Component.AccountForgotPassword]);
		};

		const submit = async () => {
			v$.value.$touch();
			const isValid = await v$.value.$validate();
			
			if (isValid) {
				loading.value = true;
				login(state.userName, state.password, props.isAgent, props.enableCreate == false)
					.then((resp) => {
						userStore.setUser({ ...resp, type: props.isAgent ? UserType.Agent : UserType.Customer });
						passengerDetailPages.setComponent(
								Component[Component.PassengerDetails]
							);
					})
					.catch((err) => {
						error.value = err.message;
					})
					.finally(() => (loading.value = false));
			}
		};

		onMounted(() => {
			if (props.enableCreate) {
				focusElement(passwordRef.value as any);
			}
		});

		return {
			submit,
			v$,
			emailLocked,
			unlockEmail,
			goToRegister,
			loading,
			passwordRef,
			goToForgotPassword,
			error
		};
	},
});
